exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".financial-report-view canvas {\n  width: 100%;\n}\n\n", ""]);

// exports
